// Copyright (c) Docugami, Inc. All rights reserved.

import { ExplorerStatusItemLabel, userFontFamily, UserInfo } from "components/common/Fonts";
import { appContentColor, emptyGray, greyText, homeGray } from "components/shell/presentation/AppStyles";
import styled, { css } from "styled-components";

export const InfoItemFooter = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    flex-direction: row;
    padding: 9px 0px;
    box-sizing: border-box;
    overflow: hidden;
    >div {
        user-select: none;
        border-right: 1px solid ${greyText};
        padding: 0px 15px
    }
    >div:last-child {
        border-right: none;
    }
`
export const ExplorerInfoText = styled(UserInfo)`
    color: ${homeGray};
    white-space: pre;
`

export const ExplorerInfoTextBold = styled(ExplorerInfoText)`
    font-weight: 800;
`

export const ExplorerTextButton = styled.span<{disabled?: boolean}>`
    font-family: ${userFontFamily};
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    color: ${emptyGray};
    user-select: none;
    ${props => !props.disabled && ExplorerTextButtonHoverCss};
`

const ExplorerTextButtonHoverCss = css`
    :hover {
        color: ${appContentColor};
        text-decoration: underline;
        cursor: pointer;
    }
`;

const ShowAllLabel = styled(ExplorerStatusItemLabel)`
    user-select: none;
    color: ${greyText};
    :after {
        content: "\u2026";
    }
    :hover {
        text-decoration: underline;
        cursor: pointer;
    }
`

export const NavigationListActionItemText = styled.span`
    font-family: ${userFontFamily};
    font-size: 16px;
    font-weight: 500;
`;

export interface ShowAllButtonProps {
    showAll: boolean;
    onClick: () => void;
}

export const ShowAllButton = (props: ShowAllButtonProps): JSX.Element => {
    const text = props.showAll ? "See less" : "See more";
    return (
        <ShowAllLabel onClick={props.onClick}>{text}</ShowAllLabel>
    )
}
